var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('company-field-list',{attrs:{"list":_vm.fieldList},on:{"select":_vm.handleSelectField}}),_c('company-user-auth-module',{attrs:{"title":"참여 인원 정보","users":_vm.users,"type":"info"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }